// src/pages/ProjectionsPage.js
import React, { useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardMedia, Typography, Box, TextField, Button, Container,Grid} from '@mui/material';
import axios from 'axios';
import './ProjectionsPage.css';
import Sidebar from '../components/Sidebar';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';
import config from '../config';


//

const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  alignContent: 'center',
  width: '100%',
  size: '100%',
});

const ContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '20px',
});

const ProjectionsPage = () => {

  const navigate = useNavigate();
  const [productId, setProductId] = useState('');
  const [productInfo, setProductInfo] = useState({});
  const [error, setError] = useState('');
  const { sessionId } = useParams();
  const [ sessionInfo, setSessionInfo ] = useState({});
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [responseLink, setResponseLink] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (event) => {
    setProductId(event.target.value);
  };

  const fetchSessionStatus = async sessionId => {
    const response = await fetch(`${config.serverUrl}/session/${sessionId}`);
    const data = await response.json();
    if (response.status == 404) {
      throw new Error('Session not found, please double check the URL');
    } else if (response.status != 200) {
      throw new Error(`Something went wrong, please try again later, ${data.message}`);
    }
    return data;
  };

  const fetchProductInfo = async () => {
    try {
      const response = await axios.get(`${config.serverUrl}/products/${productId}`);
      setProductInfo(response.data);
      setError('');
    } catch (error) {
      setError('Failed to fetch product information.');
      setProductInfo({});
    }
  };

  const handleClick = async () => {
    try {
      const response = await axios.post(config.serverUrl, {
        data: {
            "product_id": productInfo.external_id,
            "session_id": config.serverUrl+"/"+ sessionInfo.product_file,
            "wrist_size": sessionInfo.wrist_size,
        },
      });

      // Assuming the link is in response.data.link
      if (response.data && response.data.link) {
        setResponseLink(response.data.link);
        setErrorMessage('');  // Clear any previous error message
      } else {
        throw new Error('Invalid response format');
      }
    } catch (error) {
      setErrorMessage(error.message || 'An error occurred');
      setResponseLink('');  // Clear the link on error
    }
  };

  useEffect(() => {
    fetchSessionStatus(sessionId)
        .then((data) => {
            setSessionInfo(data);
        })
        .catch((error) => {
            console.error(error);
        });
    }, [sessionId]);

  return (
    <PageContainer>
      <Sidebar navigate={navigate} />
      <ContentContainer>
        <Box mb={2}>
          <TextField
            label="Product ID"
            variant="outlined"
            value={productId}
            onChange={handleInputChange}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={fetchProductInfo}
            style={{ marginTop: '10px' }}
          >
            Get Product Info
          </Button>
        </Box>
        {error && <Typography color="error">{error}</Typography>}

        <Container>
            <Grid container spacing={1}>
                {sessionInfo && (
                    <Card sx={{ maxWidth: 500 }}>
                    <CardMedia
                      component="img"
                      image={`${config.serverUrl}/${sessionInfo.files?.[2]}`}
                      alt={sessionInfo.session_id}
                       sx={{
                        width: '100%',
                        maxWidth: 300,
                        height: 300,
                        objectFit: 'contain',
                        display: 'block',
                      }}
                      >
                    </CardMedia>
                        <Box mt={4} p={2}>
                            <Typography variant="h4">Session Info</Typography>
                            <Typography variant="body1">Session ID: {sessionInfo.session_id}</Typography>
                            <Typography variant="body1">Status: {sessionInfo.status}</Typography>
                            <Typography variant="body1">Wrist size: {sessionInfo.wrist_size}</Typography>
                        </Box>
                    </Card>
                    )
                }

                {productInfo && (
                  <Card  sx={{ maxWidth: 500 }}>
                    <CardMedia
                      component="img"
                      image={productInfo.cover_url}
                      alt={productInfo.name}
                      sx={{
                        width: '100%',
                        maxWidth: 300,
                        height: 300,
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                    <Box mt={4} p={2}>
                      <Typography variant="h4">Product Info</Typography>
                      <Typography variant="body2">{productInfo.name}</Typography>
                      <Typography variant="body2">Id: {productInfo.id}</Typography>
                      <Typography variant="body2">extern_id: {productInfo.extern_id}</Typography>
                      <Typography variant="body2">{productInfo.external_id}</Typography>
                      <Typography variant="body2">{productInfo.retailer}</Typography>
                      <Typography variant="body2" color="textSecondary">{productInfo.retailer_domain}</Typography>
                    </Box>
                  </Card>
                )}

            </Grid>
             {productInfo && productInfo.extern_id && sessionInfo &&(
                <div>
                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'right', gap: 2 }}>

                      <Button variant="contained" color="primary" onClick={handleClick}>
                        Start render
                      </Button>
                      {responseLink && (
                        <Typography variant="body1">
                          Success! Here is your link: <a href={responseLink} target="_blank" rel="noopener noreferrer">{responseLink}</a>
                        </Typography>
                      )}
                      {errorMessage && (
                        <Typography variant="body1" color="error">
                          Error: {errorMessage}
                        </Typography>
                      )}
                    </Box>
                </div>
             )}
        </Container>
      </ContentContainer>
    </PageContainer>
  );
};

export default ProjectionsPage;
